import React, { Component, Fragment } from 'react';

class InventoryLoadingUI extends Component {

    render() {

        return(
          <div className="checkout--loading-state">
            <i className="icon-spinner loading__spinner" aria-hidden="true" />
          </div>
        )
    }

}

InventoryLoadingUI.propTypes = {

}

export default InventoryLoadingUI;
